import React from 'react';

const lockIconUrl = 'https://cdn.obsessvr.com/tommy-lock.png';
const bgImg = 'https://cdn.obsessvr.com/ralph-lauren/rl-bottom-menu-bg-pattern.jpg';

const BottomBarSelectorItem = ({ index, className, scene, widthPercent, selectedBorderWidth, currentlySelected, isLocked, onSelectorOptionClicked }) => {
    return (
        <div
            key={scene.scene_id}
            className={className}
            style={{
                width: widthPercent,
                borderWidth: currentlySelected && selectedBorderWidth,
                fontFamily: 'LeJeuneDeck-Regular',
                cursor: currentlySelected ? '' : 'pointer',
                //backgroundImage: `url(` + `${bgImg}` + `)`
            }}
            onMouseDown={(e) => { onSelectorOptionClicked(e, scene.scene_id, isLocked) }}
            onTouchEnd={(e) => { onSelectorOptionClicked(e, scene.scene_id, isLocked) }}
            >
            <span className={isLocked ? 'locked-selector-text' : 'glowing-selector-text'}>{scene.name === "her" ? "H.E.R." : scene.name}
                {isLocked && <img className='bottom-bar-selector-lock-icon' src={lockIconUrl}></img>}
            </span>
        </div>
    )
}

export default BottomBarSelectorItem